<template>
  <div>
  <modal name="modalVerificarFirmaElectronica" width="500" height="auto" persistent="true">
      <div class="modal-header" style="padding:8px">
        <div class="row">
          <div class="col-md-10">Verificar firma electronica</div>
        </div>
      </div>
      <div class="modal-body" style="padding:10px;">
        <div class="row">
          <div class="col-md-12">
            <p> <span style="font-weight: 600;">Digita tu firma electronica!</span> <br>
            Verifica la firma electronica para validar los registros que hagas en la historia clinica de los pacientes.</p>
          </div>
            <div class="col-md-12">
              <p style="font-size: 12px;">
                <span style="font-weight: 600;">Recuerda:</span> <br>
                <span>La firma electronica es de uso personal, recomendarlos no guardarla en el navegador.</span>
              </p>
            </div>
          <div class="col-md-12">
            <input type="password" v-model="inputFirma" placeholder="********" class="form-control">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-12">
            <button class="btn btn-success" @click="verificarFirmaElectronica()">Verificar firma</button>
          </div>
        </div>
      </div>
    </modal>
    <modal name="modalFaltaInformacion" :clickToClose="false" width="550px" height="auto">
      <div class="modal-header">
        <h4 class="modal-title" style="color:#991b1b;">Alerta</h4>
      </div>
      <div class="modal-body">
        <div>
          <span>
            Revisa los siguientes puntos para poder registrar la evolución
          </span>
          <br> <br>
          <span style="color:#991b1b; font-weight: 300;">Recuerda que tienes hasta el <span style="font-weight: bold; color: #991b1b;">{{ eventoSeleccionado.fechaFinEvolucion | date }}</span> para registrar la evolución y que no quede marcada como atrasada</span>

        </div>
        <div class="row">
          <br>
          <div class="col-md-12" v-if="informacionEvaluacion.motivos == 0">
            <div class="card-information">
              <p style="font-weight: bold;"> Motivo de consulta </p>
              <p > Debes verificar o registrar un motivo de consulta </p>
            </div>
          </div>
          <div class="col-md-12" style="margin-top:15px" v-if="informacionEvaluacion.impresion == 0">
            <div class="card-information">
              <p style="font-weight: bold;"> Impresión diagnostica </p>
              <p > Debes registrar una impresión diagnostica </p>
            </div>
          </div>
          <div class="col-md-12" style="margin-top:15px" v-if="informacionEvaluacion.plan == 0">
            <div class="card-information">
              <p style="font-weight: bold;"> Plan de tratamiento </p>
              <p > Debes registrar un plan de tratamiento </p>
            </div>
          </div>
          <div class="col-md-12">
            <br>
            <span>Los siguientes puntos no son requeridos para poder efectuar la evolución</span>
          </div>

          <div class="col-md-12" style="margin-top:15px">
            <div class="card-information-no-require">
              <p style="font-weight: bold;"> Examenes de paciente </p>
              <p > Solo debes registrar examenes en caso que el paciente lo requiera </p>
            </div>
          </div>
          <div class="col-md-12" style="margin-top:15px">
            <div class="card-information-no-require">
              <p style="font-weight: bold;"> Antecedentes </p>
              <p > Solo debes registrar antecedentes en caso que sea necesario </p>
            </div>
          </div>
          <div class="col-md-12" style="margin-top: 25px;" 
          @click="cerrarModalInformacionFaltante()">
            <button class="btn btn-danger btn-block btn-lg" style="border-radius:5px"> <i class="fa fa-arrow-left"></i> Volver a la agenda</button>
          </div>
        </div>
      </div>
    </modal>
    <div class="card" style="padding: 2%">
      <div class="modal-header" style="padding: 0px">
        <div class="row">
          <div class="col-md-10">
            <p>
              <!-- <i
                class="fa fa-calendar text-success"
                style="font-size: 26px; margin-right: 7px"
              ></i> -->
              <span style="font-weight: 600; font-size: 20px;">Agenda de evoluciones</span> <br>
              <span style="font-size: 16px; color: grey">Registra la evolución del paciente</span>
            </p>
          </div>
        </div>
      </div>
      <div class="card-content" v-if="agenda == true">
        <div class="row">
          <div class="col-12">
            <div id="calendarEl">
              <br />
              <template>
                <FullCalendar
                  defaultView="listWeek"
                  :hiddenDays="[]"
                  :locale="'esLocale'"
                  :plugins="calendarPlugins"
                  :events="arrayEventos"
                  :header="headers"
                  @eventClick="verEvento"
                  ref="fullCalendar"
                >
                </FullCalendar>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div
        class="card-content"
        v-if="agenda == false && eventoSeleccionado.nombrePaciente != ''"
      >
        <!-- <header class="modal-header" style="padding: 8px">
          <div class="row">
            <div class="col-md-7">
              <strong>Detalle de la terapia</strong>
            </div>
          </div>
        </header> -->
        <section class="modal-body" style="padding: 8px">
          <div class="row">
            <div class="col-md-12">
              <center>
                <!-- <img
                  style="border-radius: 7px"
                  width="100"
                  v-if="eventoSeleccionado.fotoPaciente != null"
                  :src="
                    'https://avanti-erp.com/' + eventoSeleccionado.fotoPaciente
                  "
                  alt=""
                /> -->
                <div class="card-alert" v-if="eventoSeleccionado.estadoEvento === 3">
                  <div class="mensaje-alerta">
                    <span style="font-weight: 500; font-size: 15px;">Recuerda</span> <br>
                    <span style="">Tienes hasta el {{ eventoSeleccionado.fechaFinEvolucion | date }} para registrar la evolución y que no quede marcada como atrasada</span>
                  </div>
                </div>
                <h4 style="font-weight: 500">
                  {{ eventoSeleccionado.nombrePaciente }}
                </h4>
                <span style="font-size: 15px; color: grey">
                  Documento de identidad: {{ eventoSeleccionado.documentoPaciente }}
                </span>
                <br />
                <span style="font-size: 15px; color: grey">
                  {{ eventoSeleccionado.fecha | date }},
                  {{ eventoSeleccionado.horainicio }} a
                  {{ eventoSeleccionado.horafin }}
                </span>
                <br />
                <br>
                <span style="font-size: 15px; padding: 5px; background-color: #2f2254; color: white; border-radius: 5px;">
                  {{ eventoSeleccionado.cantidadSesiones }} Sesion(es)
                </span>
              </center>
            </div>
            <div
              class="row"
              v-if="
                eventoSeleccionado.tipo == 'Terapia' &&
                eventoSeleccionado.estadoEvento == 3
              "
            >
              <br />

              <div class="col-md-12">
                <label for="estrategiatp"
                  >Estrategias terapeuticas implementada</label
                >
                <!-- <select class="form-control" id="estrategiatp" v-model="estrategia">
                  <option
                    v-for="estrategia in arrayEstrategiasActivos"
                    :key="estrategia.DomDes"
                    :value="estrategia.DomDes"
                  >
                    {{ estrategia.DomDes }}
                  </option>
                </select> -->
                <el-select
                multiple
                class="select-default"
                size="large"
                style="width: 100%;"
                v-model="estrategia"
                placeholder="Seleccione estrategias terapeuticas implementadas"
                filterable
                remote
              >
                <el-option
                  
                  v-for="estrategia in arrayEstrategiasActivos"
                  class="select-primary"
                  :value="estrategia.DomDes"
                  :label="estrategia.DomDes"
                  :key="estrategia.DomDes"
                ></el-option>
              </el-select>
              </div>
              <div class="col-md-12">
                <br>
                <label for="estadoPaciente">Describe en que estado estaba el paciente</label>
                <textarea
                  id="estadoPaciente"
                  class="form-control"
                  cols="30"
                  maxlength="200"
                  v-model="estadoPaciente"
                  rows="2"
                ></textarea>
                <small>{{ estadoPaciente.length }} / 200</small>
              </div>
              <div class="col-md-12">
                <br>
                <label for="evoluciontp">Describe lo que se realizó en la terapia</label>
                <textarea
                  id="evoluciontp"
                  class="form-control"
                  cols="30"
                  maxlength="1000"
                  v-model="evolucion"
                  rows="10"
                ></textarea>
                <small>{{ evolucion.length }} / 1.000</small>
              </div>
            </div>
            <div
              class="row"
              v-if="
                eventoSeleccionado.tipo == 'Evaluacion' &&
                eventoSeleccionado.estadoEvento == 3
              "
              style="margin-left: 50px; margin-right: 50px"
            >
              <div class="col-md-12">
                <br />
                <center>
                  <div class="cardcyt">
                    <div style="font-size: 18px;">
                      <i class="fa fa-info" title="Si marcas como requerido ✅, al momento de exportar el informe se valida si el paciente tiene examenes cargados en la fecha de la evaluación"></i>
                      <label for="requiere">El paciente requiere examen?</label>
                      <input type="checkbox" class="form-check-input" v-model="requiere" id="requiere">
                    </div>
                    <h3 style="font-weight: bold">
                      Dale clic en evolucionar y terminar la evaluación en el
                      modulo de historia clinica
                    </h3>
                  </div>
                </center>
                <br />
              </div>
            </div>
            <div class="row" v-if="eventoSeleccionado.estadoEvento != 3">
              <div class="col-md-12">
                <br />
                <center>
                  <h4
                    style="color: green"
                    v-if="eventoSeleccionado.estadoEvento == 1"
                  >
                    Sesión evolucionada con éxito
                  </h4>
                  <h4
                    style="color: red"
                    v-if="eventoSeleccionado.estadoEvento == 2"
                  >
                    Sesión cancelada
                  </h4>
                </center>
              </div>
            </div>
          </div>
        </section>
        <footer>
          <div class="modal-footer" style="padding-bottom: 9px">
            <center>
              <button
                type="button"
                style="border-radius: 5px"
                class="btn btn-error"
                @click="
                  agenda = true;
                  eventoSeleccionado = [];
                "
              >
               Cerrar
              </button>
              <button
                v-if="eventoSeleccionado.estadoEvento == 3"
                type="button"
                style="border-radius: 5px"
                class="btn btn-success btn-fill"
                @click="registrarEvolucion()"
              >
              Registrar evolución
              </button>
            </center>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import esLocale from "@fullcalendar/core/locales/es";
import listPlugin from "@fullcalendar/list";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { toMoment } from "@fullcalendar/moment";
import googleCalendarPlugin from "@fullcalendar/google-calendar";
import crearAlerta from "../../global-services/crearAlerta";
import getCurrentDate from "../../global-services/fecha-actual";
import { Table, TableColumn, Select, Option } from "element-ui";
import axiosInstance from "../../global-services/axiosInstance";
Vue.use(Select);
Vue.use(Option);

export default {
  data() {
    return {
      ip: "https://avanti-erp.com",
      agenda: true,
      arrayEventos: [],
      eventoSeleccionado: [],
      arrayEstrategiasActivos: [],
      arrayMaterialesActivos: [],
      fechaActual: "",
      requiere: false,

      evolucion: "",
      estadoPaciente: "",
      estrategia: "",
      // calendar
      calendarPlugins: [
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin,
        listPlugin,
        googleCalendarPlugin,
      ],
      headers: {
        left: "prev,today,next",
        center: "",
        // right: "dayGridMonth,timeGridWeek,listWeek,timeGridDay",
        right: "title",
      },
      informacionEvaluacion: {
        motivos: 0,
        impresion: 0,
        plan: 0
      }
    };
  },
  methods: {
    verEvento: function (arg) {

      const EVENT = arg.event.extendedProps;
      if (EVENT.fecha > this.fechaActual) {
        this.$notify(
          crearAlerta(
            "danger",
            "No se puede ingresar la evolución porque la fecha del evento es superior a la fecha actual"
          )
        );
        return;
      }
      this.eventoSeleccionado = EVENT;
      this.agenda = false;
      if (EVENT.tipo === 'Evaluacion' && EVENT.estadoEvento === 3) {
        this.verificarRegistrosEvaluacionHistoriaClinica(EVENT.fecha, EVENT.pacienteId, EVENT.usuarioTerapeuta);
      }
    },
    verificarRegistrosEvaluacionHistoriaClinica: async function (fecha, paciente, terapeuta) {
      try {
        this.$modal.show("carga");
        const url = `/api/verificar-registros-evaluacion-historia-clinica/${fecha}/${paciente}/${terapeuta}`;
        const response = await axiosInstance.get(url);
        const data = response.data;
        const { motivos, planes, impresiones } = data;
        this.informacionEvaluacion.motivos = motivos;
        this.informacionEvaluacion.plan = planes;
        this.informacionEvaluacion.impresion = impresiones;
        if (motivos == 0 || impresiones == 0 || planes == 0) {
          this.mostrarModalFaltaInformacion();
        }
      } catch (error) {
        this.$notify(
          crearAlerta(
            "danger",
            "Ocurrió un error verificando la información de la historia clinica, contacte al administrador del sistema"
          )
        );
        return;
      } finally {
        this.$modal.hide("carga");
      }
    },
    mostrarModalFaltaInformacion: function () {
      this.$modal.show("modalFaltaInformacion");
    },
    cerrarModalInformacionFaltante: function () {
      this.eventoSeleccionado = [];
      this.agenda = true;
      this.$modal.hide("modalFaltaInformacion");
      this.informacionEvaluacion = {
        motivos: 0,
        impresion: 0,
        plan: 0
      }
    },
    obtenerEventos: function (tipoBusqueda) {
      const CRITERIO =
        tipoBusqueda === "sede"
          ? "programacion.sede"
          : "programacion.terapeuta";
      const BUSQUEDA =
        tipoBusqueda === "sede"
          ? localStorage.getItem("sede")
          : localStorage.getItem("usuario");
      console.log(BUSQUEDA);
      this.$modal.show("carga");
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}/api/obtener-eventos-calendario/${CRITERIO}/${BUSQUEDA}`;
      axios
        .get(BASE_URL, config)
        .then((res) => {
          this.$modal.hide("carga");
          let data = res.data.data;
          let events = [];
          data.forEach((element) => {
            if (element.tipo != "CYT") {
              events.push({
                // title: element.summary,
                title: `${element.nombrePaciente} ${element.apellidoPaciente}`,
                // description: 'Terapia',
                start: `${element.fecha}T${element.horaInicio}`,
                end: `${element.fecha}T${element.horaFin}`,
                color:
                  element.estadoEvento === 3
                    ? "blue"
                    : element.estadoEvento === 2
                    ? "red"
                    : "green",
                extendedProps: {
                  nombreTerapeuta: `${element.nombreTerapeuta} ${element.apellidoTerapeuta}`,
                  usuarioTerapeuta: element.terapeuta,
                  pacienteId: element.usuarioId,
                  especialidad: element.especialidad,
                  autorizacion: element.autorizacion,
                  fecha: element.fecha,
                  tipo: element.tipo,
                  horainicio: element.horaInicio,
                  horafin: element.horaFin,
                  documentoPaciente: element.documentoPaciente,
                  cantidadSesiones: parseInt(element.sesionesCantidad),
                  estadoEvento: element.estadoEvento,
                  idEvento: element.idEvento,
                  fotoPaciente: element.url_foto,
                  nombrePaciente: `${element.nombrePaciente} ${element.apellidoPaciente}`,
                  fechaFinEvolucion: element.fechaFinEvolucion,
                },
              });
            }
          });

          this.arrayEventos = events;
        })
        .catch((err) => {
          this.$modal.hide("carga");
          console.log(err);
        });
    },
    registrarEvolucion: function () {

      const EVENT = this.eventoSeleccionado;
      let atrasado = "no";
      if(EVENT.fechaFinEvolucion < this.fechaActual){
        atrasado = "si";
        this.$notify(crearAlerta('danger', 'La evolución se hará una fecha posterior a la programación, por lo tanto se pagará a la mitad.'));
      }

      
      const EVOLUCION =
        EVENT.tipo === "Terapia" ? `${this.estadoPaciente} \n\n${this.evolucion} \n\nDurante la sesión se implementarion las siguientes estrategias terapéuticas: ${this.estrategia.join(", ")}.` : "Se realizó una evaluación";
      const ESTRATEGIA = EVENT.tipo === "Terapia" ? this.estrategia.join(", ") : "Evaluación";
     
      if (EVOLUCION === "" || ESTRATEGIA === "") {
        this.$notify(crearAlerta("danger", "Faltan campos por llenar"));
        this.$modal.hide("carga");
        return;
      }
      this.$modal.show("carga");
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const BASE_URL = `${this.ip}/api/registrar-evolucion-calendario`;
      axios
        .post(
          BASE_URL,
          {
            EVENT: EVENT,
            evolucion: EVOLUCION,
            estrategia: ESTRATEGIA,
            material: null,
            atrasado: atrasado,
            requiereExamen: this.requiere ? 1 : 0,
          },
          config
        )
        .then((res) => {
          this.$modal.hide("carga");
          if (res.data.status === true) {
            this.evolucion = "";
            this.estrategia = "";
            this.agenda = true;
            this.$modal.hide("detalle_terapia");
            this.obtenerEventos("terapeuta");
            this.$notify(crearAlerta("success", res.data.mensaje));
          }
        })
        .catch((err) => {
          this.$modal.hide("carga");
          this.$notify(crearAlerta("danger", res.data.mensaje));
          console.log(err);
        });
    },
    dominio(dominio) {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const url = `${this.ip}/api/dominio/${dominio}`;
      axios.get(url, config).then((res) => {
        this.arrayMaterialesActivos = res.data.data;
      });
    },
    estrategias(dominio) {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const url = `${this.ip}/api/dominio/${dominio}`;
      axios.get(url, config).then((res) => {
        this.arrayEstrategiasActivos = res.data.data;
      });
    },
    cerrarModal: function (modal) {
      this.$modal.hide(modal);
    },

    verificarFirmaElectronica: function(){
      this.$modal.show('carga');
      const FIRMA = localStorage.getItem('firmaElectronica');
      if(this.inputFirma === FIRMA){
        this.$notify(crearAlerta("success", 'Firma valida'));
        this.$modal.hide('modalVerificarFirmaElectronica');
        this.$modal.hide('carga');
      }else{
        this.$notify(crearAlerta("danger", "Firma invalida"));
        this.$modal.hide('carga');
      }
    },

    abrirModalVerificarFirma: function(){
      const ROL = localStorage.getItem('rol');
      if(ROL >= 1 && ROL < 7){
        this.$modal.show('modalVerificarFirmaElectronica');
      }
    },
  },
  mounted() {
    window.document.title = "Avanti | Mi agenda";
    if (!localStorage.getItem("token")) {
      this.$router.push("/");
    } else {
      this.obtenerEventos("terapeuta");
      this.rol = localStorage.getItem("rol");
      this.dominio(parseInt(this.rol) + 30);
      this.estrategias(parseInt(this.rol) + 20);
      this.fechaActual = getCurrentDate();
      this.abrirModalVerificarFirma()
    }
  },
  components: {
    FullCalendar,
  },
};
</script>
<style scoped>
.cardcyt {
  background-color: rgb(242, 242, 242);
  margin-top: 5px;
  border-radius: 7px;
  padding: 12px;
}

.card-information{
  border: 1px solid #fef2f2;
  width: 100%;
  height: 9vh;
  padding: 5px;
  border-radius: 5px;
  color: #991b1b;
  background-color: #fef2f2;
}

.card-information-no-require{
  border: 1px solid #fffbeb;
  width: 100%;
  height: 10vh;
  padding: 5px;
  border-radius: 5px;
  color: #92400e;
  background-color: #fffbeb;
}

label{
  font-weight: 400;
}

.card-alert{
  border: 1px solid #fef2f2;
  width: 100%;
  height: 9vh;
  padding: 5px;
  border-radius: 5px;
  color: #991b1b;
  background-color: #fef2f2;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 35%;
}

@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";
@import "~@fullcalendar/timegrid/main.css";
@import "~@fullcalendar/list/main.css";
</style>


// WEBPACK FOOTER //
// src/components/Diario-De-Campo/evoluciones-citas.vue